module.exports = __webpack_public_path__ + "assets/img/Hunan.f2866850.png";